import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from 'src/core/services/crud/crud.service';
import { ListResponseDto } from 'src/core/models/request/list-response.dto';
import { InboundNumberDto } from '../models/inbound-number.dto';
import { IvrInstanceLookupDto } from '../models/ivr-instance-lookup.dto';
import { PhoneNumberConnectivityResultDto } from '../models/phone-number-connectivity-result.dto';

@Injectable({ providedIn: 'root' })
export class InboundNumberService {
  private readonly crudService = inject(CrudService);

  getList(skipCount = 0, maxResultCount = 10): Observable<ListResponseDto<InboundNumberDto>> {
    return this.crudService.get<InboundNumberDto>(InboundNumberDto, {
      skipCount,
      maxResultCount,
      filters: [],
      sorters: [],
    });
  }

  getById(id: number): Observable<InboundNumberDto> {
    return this.crudService.getWithSuffix<InboundNumberDto>(InboundNumberDto, id);
  }

  create(dto: InboundNumberDto): Observable<InboundNumberDto> {
    return this.crudService.insertWithoutId<InboundNumberDto>(InboundNumberDto, dto);
  }

  update(dto: InboundNumberDto & { id: number }): Observable<InboundNumberDto> {
    return this.crudService.update<InboundNumberDto>(
      InboundNumberDto,
      dto as unknown as { id: number } & Record<string, unknown>,
    );
  }

  delete(id: number): Observable<unknown> {
    return this.crudService.delete(InboundNumberDto, id);
  }

  activate(id: number): Observable<void> {
    return this.crudService.insertWithoutId<void>(
      InboundNumberDto,
      {} as unknown as void,
      `${id}/activate`,
    );
  }

  deactivate(id: number): Observable<void> {
    return this.crudService.insertWithoutId<void>(
      InboundNumberDto,
      {} as unknown as void,
      `${id}/deactivate`,
    );
  }

  getAssignedIvrInstances(): Observable<IvrInstanceLookupDto[]> {
    return this.crudService.getSimple<IvrInstanceLookupDto[]>(
      InboundNumberDto,
      null,
      'assigned-ivr-instances',
    );
  }

  testConnectivity(id: number): Observable<PhoneNumberConnectivityResultDto> {
    return this.crudService.insertWithoutId<PhoneNumberConnectivityResultDto>(
      InboundNumberDto,
      {} as unknown as PhoneNumberConnectivityResultDto,
      `${id}/test-connectivity`,
    );
  }
}
